import { ArtichokePresence } from "@closerplatform/spinner-openapi";
import React from "react";
import styles from "./guestStatusIndicator.css";

interface Props {
  status: ArtichokePresence;
  shouldAnimate?: boolean;
}

export const GuestStatusIndicator: React.StatelessComponent<Props> = ({
  status,
  shouldAnimate
}) => {
  switch (status) {
    case ArtichokePresence.Available:
      return (
        <div
          className={`
          ${styles["guest-status-indicator"]}
          ${styles["status-available"]}
          ${shouldAnimate ? styles["animated-showing"] : ""}`}
        />
      );
    case ArtichokePresence.Unavailable:
      return (
        <div
          className={`
          ${styles["guest-status-indicator"]}
          ${shouldAnimate ? styles["animated-hiding"] : ""}`}
        />
      );
    default:
      return <div />;
  }
};
